import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomeSection from './pages/Home';
import OverMijSection from './pages/OverMij';
import WerkwijzeSection from './pages/Werkwijze';
import StressBurnoutSection from './pages/StressBurnout';
import ContactSection from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import FAQModal from './components/FAQModal';
import CVModal from './components/CVModal';
import TrustBar from './components/TrustBar';
import SurvivalToRest from './components/SurvivalToRest';

const VoorMedewerkers = lazy(() => import('./pages/VoorMedewerkers'));
const Stressproblematiek = lazy(() => import('./pages/Stressproblematiek'));
const BurnoutCoaching = lazy(() => import('./pages/BurnoutCoaching'));
const Blog = lazy(() => import('./pages/Blog'));
const Admin = lazy(() => import('./pages/Admin'));

const App: React.FC = () => {
  const [faqOpen, setFaqOpen] = useState(false);
  const [cvOpen, setCvOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Als er een hash is (#stress-check), scroll daar dan naar toe
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Kleine timeout om te zorgen dat de DOM gerenderd is
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Geen hash? Dan gewoon naar boven
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const handleOpenFAQ = () => setFaqOpen(true);
    const handleOpenCV = () => setCvOpen(true);
    
    window.addEventListener('openFAQModal', handleOpenFAQ);
    window.addEventListener('openCVModal', handleOpenCV);
    
    return () => {
      window.removeEventListener('openFAQModal', handleOpenFAQ);
      window.removeEventListener('openCVModal', handleOpenCV);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Suspense fallback={
          <div className="min-h-screen bg-liza-bg flex items-center justify-center">
            <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
        }>
          <Routes>
            <Route path="/" element={
              <>
                <section id="home" className="scroll-mt-0">
                  <HomeSection />
                </section>
                <TrustBar />
                <SurvivalToRest />
                <section id="werkwijze" className="scroll-mt-24">
                  <WerkwijzeSection />
                </section>
                <section id="over-mij" className="scroll-mt-24">
                  <OverMijSection />
                </section>
                <StressBurnoutSection />
                <section id="contact" className="scroll-mt-24">
                  <ContactSection />
                </section>
              </>
            } />
            <Route path="/medewerkers" element={<VoorMedewerkers />} />
            <Route path="/stressproblematiek" element={<Stressproblematiek />} />
            <Route path="/burnout-coaching" element={<BurnoutCoaching />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/contact" element={<section id="contact" className="pt-20"><ContactSection isStandalone={true} /></section>} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppButton />
      
      {/* Global Modals */}
      <FAQModal isOpen={faqOpen} onClose={() => setFaqOpen(false)} />
      <CVModal isOpen={cvOpen} onClose={() => setCvOpen(false)} />
    </div>
  );
};

export default App;